// Generated by LiveScript 1.6.0
var each, registry, domQuery, registerDirective, markDirective, listeners, classify, makeModel, showDirective, bindDirective, onListeners, onDirective, registerBuiltins;
each = require('./fn').each;
registry = require('./registry');
domQuery = require('./dom-query');
registerDirective = curry$(function(ctx, name, cb, isParametric){
  isParametric == null && (isParametric = false);
  if (!ctx.directives.has(name)) {
    ctx.directives.set(name, {
      cb: cb,
      isParametric: isParametric
    });
    return each(function(it){
      return registry.scanAndRegister(ctx.registry, it, ctx);
    })(
    Array.from(document.querySelectorAll("[" + ctx.prefix + name + "]")));
  }
});
markDirective = function(arg$){
  var el, value, isDelete;
  el = arg$.el, value = arg$.value, isDelete = arg$.isDelete;
  switch (false) {
  case !isDelete:
    return el.remove();
  case !!(el instanceof HTMLElement):
    break;
  case !(typeof value === 'object' && value != null):
    if (!(el.children.length > 0)) {
      return el.textContent = JSON.stringify(value);
    }
    break;
  default:
    return el.textContent = String(value);
  }
};
listeners = new WeakMap;
classify = function(el){
  switch (false) {
  case !(el instanceof HTMLInputElement):
    switch (el.type) {
    case 'checkbox':
      return 'checkbox';
    case 'radio':
      return 'radio';
    case 'number':
      return 'number';
    default:
      return 'text';
    }
  case !(el instanceof HTMLTextAreaElement):
    return 'text';
  case !(el instanceof HTMLSelectElement):
    return 'select';
  case el.contentEditable !== 'true':
    return 'editable';
  default:
    return null;
  }
};
makeModel = function(ctx){
  return function(arg$){
    var el, value, key, kind, str, event;
    el = arg$.el, value = arg$.value, key = arg$.key;
    if (!(kind = classify(el))) {
      return;
    }
    switch (kind) {
    case 'checkbox':
      el.checked = value === true;
      break;
    case 'radio':
      el.checked = el.value === String(value);
      break;
    case 'editable':
      str = value != null ? String(value) : '';
      if (el.textContent !== str && document.activeElement !== el) {
        el.textContent = str;
      }
      break;
    default:
      str = value != null ? String(value) : '';
      if (el.value !== str) {
        el.value = str;
      }
    }
    if (!listeners.has(el)) {
      event = (function(){
        switch (kind) {
        case 'checkbox':
          return 'change';
        case 'select':
          return 'change';
        default:
          return 'input';
        }
      }());
      el.addEventListener(event, function(){
        var ref$, parent, prop, incoming;
        ref$ = domQuery.getValue(ctx, key), parent = ref$.parent, prop = ref$.prop;
        if (parent != null) {
          incoming = (function(){
            switch (kind) {
            case 'checkbox':
              return el.checked;
            case 'number':
              return el.valueAsNumber;
            case 'editable':
              return el.textContent;
            default:
              return el.value;
            }
          }());
          return Reflect.set(parent, prop, incoming);
        }
      });
      return listeners.set(el, true);
    }
  };
};
showDirective = function(arg$){
  var el, value;
  el = arg$.el, value = arg$.value;
  return el.style.display = value ? '' : 'none';
};
bindDirective = function(arg$){
  var el, value, param, isDelete;
  el = arg$.el, value = arg$.value, param = arg$.param, isDelete = arg$.isDelete;
  if (param == null) {
    return;
  }
  if (isDelete || value == null || value === false) {
    return el.removeAttribute(param);
  } else if (value === true) {
    return el.setAttribute(param, '');
  } else {
    return el.setAttribute(param, String(value));
  }
};
onListeners = new WeakMap;
onDirective = function(arg$){
  var el, value, param, map;
  el = arg$.el, value = arg$.value, param = arg$.param;
  if (param == null) {
    return;
  }
  if (!onListeners.has(el)) {
    onListeners.set(el, {});
  }
  map = onListeners.get(el);
  if (map[param] != null) {
    if (map[param] === value) {
      return;
    }
    el.removeEventListener(param, map[param]);
    delete map[param];
  }
  if (typeof value === 'function') {
    el.addEventListener(param, value);
    return map[param] = value;
  }
};
registerBuiltins = function(ctx){
  ctx.directives.set('mark', {
    cb: markDirective,
    isParametric: false
  });
  ctx.directives.set('model', {
    cb: makeModel(ctx),
    isParametric: false
  });
  ctx.directives.set('show', {
    cb: showDirective,
    isParametric: false
  });
  ctx.directives.set('bind', {
    cb: bindDirective,
    isParametric: true
  });
  return ctx.directives.set('on', {
    cb: onDirective,
    isParametric: true
  });
};
module.exports = {
  registerDirective: registerDirective,
  registerBuiltins: registerBuiltins
};
function curry$(f, bound){
  var context,
  _curry = function(args) {
    return f.length > 1 ? function(){
      var params = args ? args.concat() : [];
      context = bound ? context || this : this;
      return params.push.apply(params, arguments) <
          f.length && arguments.length ?
        _curry.call(context, params) : f.apply(context, params);
    } : f;
  };
  return _curry();
}